import React, { useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";

import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";

import {
	Divider,
	Grid,
	Typography,
} from "@material-ui/core";

import { Loader, FormSubmitButton } from "frame/components";
import AlertEmail from "./alert-email";

const useStyles = makeStyles((theme) => ({
	root: {
		margin: theme.spacing(3, 0, 2, 0),
		maxWidth: 800,
		"& > *": {
			paddingLeft: "0 !important",
			paddingRight: "0 !important",
		},
	},
	section: {
		marginBottom: theme.spacing(3),
	},
	sectionHeading: {
		fontWeight: theme.typography.fontWeightBold,
	},
	description: {
		marginTop: theme.spacing(0.5),
		marginBottom: theme.spacing(2),
		color: theme.palette.text.secondary,
		fontSize: "0.875rem",
	},
	list: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "stretch",
		minHeight: 50,
	},
	divider: {
		margin: theme.spacing(2, 0),
	},
}));

const AlertEmailForm = ({
	emails = [],
	loading,
	onSave,
	embedded = false,
}) => {
	const classes = useStyles();
	const [email, setEmail] = useState("");

	const showLoader = loading && !emails.length;
	const showEmpty = !loading && !emails.length;

	const onSubmit = () => {
		const next = Array.from(new Set([...emails, email]));
		setEmail("");
		onSave(next);
	};

	const onRemove = (index) => {
		const next = [...emails.slice(0, index), ...emails.slice(index + 1)];
		onSave(next);
	};

	const onChange = (event) => setEmail(event.target.value);

	return (
		<>
			<ValidatorForm autoComplete="off" noValidate onSubmit={onSubmit}>
				<Grid className={embedded ? undefined : classes.root} container spacing={2}>
					<Grid item xs={12}>
						<div className={classes.list}>
							{showLoader && <Loader />}
							{showEmpty && (
								<Typography variant="body2">
									No emails listed to receive alerts.
								</Typography>
							)}
							{emails.map((node, index) => (
								<AlertEmail
									key={index}
									email={node}
									onRemove={() => onRemove(index)}
								/>
							))}
						</div>
						<Divider className={classes.divider} />
					</Grid>
					<Grid item xs={12} sm={8}>
						<TextValidator
							id={"email"}
							fullWidth
							label="Email"
							value={email || ""}
							variant="outlined"
							size="small"
							validators={["required", "isEmail"]}
							errorMessages={[
								"This field is required",
								"Must be a valid email",
							]}
							onChange={onChange}
						/>
					</Grid>
					<Grid item xs={12} sm={4}>
						<FormSubmitButton fullWidth={!embedded}>Add Email</FormSubmitButton>
					</Grid>
				</Grid>
			</ValidatorForm>
		</>
	);
};

AlertEmailForm.propTypes = {
	emails: PropTypes.array,
	loading: PropTypes.bool,
	onSave: PropTypes.func,
	embedded: PropTypes.bool,
};

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(AlertEmailForm);
